/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {error, info, warn} from '../logger/logger';

// Provides the Datadog initialization success logger ...
export const logInitializeSuccess = () => {
  info(_messages.initialize.success);
};

// Provides the Datadog initialization error logger ...
export const logInitializeError = () => {
  error(_messages.initialize.error);
};

// Provides the Datadog initialization configuration error logger ...
export const logInitializeConfigError = () => {
  warn(_messages.initialize.config);
};

// Provides the Datadog initialization already available error logger ...
export const logInitializeAvailableError = () => {
  error(_messages.initialize.available);
};

// Provides the Datadog identify user success logger ...
export const logIdentifyUserSuccess = () => {
  info(_messages.identifyUser.success);
};

// Provides the Datadog identify user not initialized error logger ...
export const logIdentifyUserInitializationError = () => {
  error(_messages.identifyUser.notInitialized);
};

// Provides the Datadog report page crash success logger ...
export const logReportPageCrashSuccess = () => {
  info(_messages.reportPageCrash.success);
};

// Provides the Datadog report page crash failure logger ...
export const logReportPageCrashFailure = () => {
  error(_messages.reportPageCrash.error);
};

// Provides a basic abstraction of Datadog log messages from API implementation.
export const _messages = {
  initialize : {
    success   : 'Datadog.initialize has completed successfully. RUM monitoring initialization complete.',
    error     : 'Datadog.initialize has failed, the Datadog RUM SDK is not available.',
    config    : 'Datadog.initialize failed, the applicationId and clientToken have not been configured.',
    available : 'Datadog.initialize has previously been invoked, the RUM SDK is already initialized.'
  },
  identifyUser : {
    success        : 'Datadog.identifyUser has completed successfully.',
    notInitialized : 'Datadog.identifyUser can not be invoked until after Datadog.initialize has been called.'
  },
  reportPageCrash : {
    success : 'Datadog.reportPageCrash logged successfully.',
    error   : 'Datadog.reportPageCrash logging failed.'
  }
};
